import { InjectionToken } from "@angular/core";

export const FEATURE_FLAGS = new InjectionToken<Record<string, boolean> | null>("FEATURE_FLAGS", {
  factory: () => null,
});
